const MODAL_ATTRIBUTE = 'data-theme-modal';
const TRIGGER_ATTRIBUTE = 'data-theme-modal-trigger';
const CLOSE_ATTRIBUTE = 'data-theme-modal-close';

const MODAL_OPEN_ATTRIBUTE = 'data-theme-modal-open';

export function setupModals() {
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    const trigger = target.closest(`[${TRIGGER_ATTRIBUTE}]`);
    const close = target.closest(`[${CLOSE_ATTRIBUTE}]`);

    if (trigger) {
      event.preventDefault();
      handleModalOpen(trigger.getAttribute(TRIGGER_ATTRIBUTE) || '');
    } else if (close) {
      event.preventDefault();
      handleModalClose();
    }
  });

  // Close modal on escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      handleModalClose();
    }
  });
}

function handleModalOpen(name: string) {
  const modal: HTMLElement = document.querySelector(`[${MODAL_ATTRIBUTE}="${name}"]`);
  if (!modal) {
    return;
  }
  modal.setAttribute(MODAL_OPEN_ATTRIBUTE, 'true');
  modal.getElementsByTagName('input')?.[0]?.focus();
}

function handleModalClose() {
  const modal = document.querySelector(`[${MODAL_OPEN_ATTRIBUTE}]`);
  if (!modal) {
    return;
  }
  modal.removeAttribute(MODAL_OPEN_ATTRIBUTE);
}
